import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Form, Input, Modal, Select } from 'antd';
import classnames from "classnames";
import MarketplaceFeeType from "../../enums/MarketplaceFeeType";
import HelpLabel from "../../components/HelpLabel";
import TenantSelect from "../../components/TenantSelect";
import UnitOfMeasureType from "../../enums/UnitOfMeasureType";
import { AccountsTypeEnum } from "../orders/api/Representation";
import CurrencyInput from "../../components/CurrencyInput";
const MarketplaceFeeModal = ({ open, fee, onCancel, onSave }) => {
    const [feeType, setFeeType] = useState(MarketplaceFeeType.ONCE_OFF);
    const [selectedProviderTenant, setSelectedProviderTenant] = useState(null);
    const [form] = Form.useForm();
    useEffect(() => {
        if (open) {
            form.resetFields();
            if (fee) {
                setFeeType(MarketplaceFeeType.valueOf(fee.type) || MarketplaceFeeType.ONCE_OFF);
                setSelectedProviderTenant(fee.providerTenant);
            }
            else {
                setFeeType(MarketplaceFeeType.ONCE_OFF);
                setSelectedProviderTenant(null);
            }
        }
    }, [open, fee]);
    const onOk = (formValues) => {
        const newFee = {
            ...fee,
            "id": fee?.id || 0,
            "version": fee?.version || 0,
            "description": formValues.description,
            "type": formValues.type,
            "chargeAmountExTax": formValues.chargeAmountExTax,
            "providerTenant": selectedProviderTenant,
            "providerAmountExTax": formValues.providerAmountExTax,
            "providerAccountsType": formValues.providerAccountsType,
            "unitOfMeasure": formValues.type === MarketplaceFeeType.PER_UOM.key ? formValues.unitOfMeasure : null,
            "fixedFee": false // Fixed fees are read only so are never added or edited here
        };
        onSave(newFee);
    };
    const onProviderTenantChanged = (tenant) => {
        setSelectedProviderTenant(tenant);
    };
    return (_jsx(Modal, { title: "Additional Charge", open: open, onOk: form.submit, onCancel: onCancel, destroyOnHidden: true, children: _jsxs(Form, { layout: "vertical", form: form, onFinish: onOk, children: [_jsx(Form.Item, { name: "description", label: "Description", initialValue: fee?.description, rules: [
                        { required: true, message: 'Please enter description' },
                        { max: 500, message: 'Please limit the description to 500 characters.' }
                    ], children: _jsx(Input, { placeholder: "Description" }) }), _jsx(Form.Item, { name: "type", label: "Type", initialValue: fee?.type || feeType, rules: [
                        { required: true, message: 'Please select a type' }
                    ], children: _jsx(Select, { allowClear: false, showSearch: false, onChange: type => setFeeType(MarketplaceFeeType.valueOf(type)), options: MarketplaceFeeType.selectOptionsArray() }) }), _jsx(Form.Item, { name: "unitOfMeasure", label: "Unit of Measure", initialValue: fee?.unitOfMeasure, className: classnames({ 'display-none': feeType !== MarketplaceFeeType.PER_UOM }), rules: [{
                            required: feeType == MarketplaceFeeType.PER_UOM,
                            message: 'Please select a unit of measure to be applied to the fee'
                        }], children: _jsx(Select, { allowClear: true, defaultActiveFirstOption: false, placeholder: "Unit of measure", options: UnitOfMeasureType.vehicleHireSelectOptionsArray() }) }), _jsx(Form.Item, { name: "chargeAmountExTax", label: _jsx(HelpLabel, { title: "Charge Amount (ex GST)", helpText: "This is the amount that will be charged to the hiring profile" }), initialValue: fee?.chargeAmountExTax, rules: [
                        { required: true, message: 'Please enter a charge amount' }
                    ], children: _jsx(CurrencyInput, { step: 0.5 }) }), _jsx(Form.Item, { name: "providerTenantId", label: "Provider", initialValue: fee?.providerTenant ? fee.providerTenant.id : null, rules: [
                        { required: true, message: 'Please select a provider that will be paid this charge' }
                    ], children: _jsx(TenantSelect, { style: { width: "100%" }, allowClear: true, onTenantSelected: onProviderTenantChanged }) }), _jsx(Form.Item, { name: "providerAccountsType", label: "Provider Accounts Type", initialValue: fee?.providerAccountsType || AccountsTypeEnum.PAYABLE, rules: [{
                            required: true,
                            message: 'Please select a provider accounts type'
                        }], children: _jsx(Select, { allowClear: true, defaultActiveFirstOption: false, placeholder: "Provider Accounts Type", options: [
                            { value: "PAYABLE", label: 'Payable (fee is paid to the provider)' },
                            { value: "RECEIVABLE", label: 'Receivable (fee is collected from the provider)' }
                        ] }) }), _jsx(Form.Item, { name: "providerAmountExTax", label: _jsx(HelpLabel, { title: "Provider Amount (ex GST)", helpText: "This is the amount that will be charged or paid to the provider.  If you leave this value empty the provider will be charged or paid the full charge amount." }), initialValue: fee?.providerAmountExTax, children: _jsx(CurrencyInput, { step: 0.5 }) })] }) }));
};
export default MarketplaceFeeModal;
